import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    {
        id: 1,
        label: 'Menu',
         visiblefor: ['all'],
        isTitle: true
    },
    {
        id: 2,
        label: 'DASHBOARD',
          visiblefor: ['all'],
            link: '/dashboard',
        icon: 'bx-home-circle',
         
    }, 
     
    {
        id: 82,
        label: 'ANAGRAFICHE',
       visiblefor: ['admin', 'super'],
        icon: 'bx-file',
        subItems: [
            
            {
                id: 83,
                label: 'Foglio',
               visiblefor: ['admin', 'super'],
                link: '/anagrafiche/wsufoglionglist',
                parentId: 82
            } ,
            {
                id: 83,
                label: 'Zone',
                visiblefor: ['admin', 'super'],
                link: '/anagrafiche/wsuzonalist',
                parentId: 82
            } 
            ,
            {
                id: 85,
                label: 'Superfici',
              visiblefor: ['admin', 'super'],
                link: '/anagrafiche/wsusuperficinglist',
                parentId: 82
            } ,
            {
                id: 85,
                label: 'Strade',
                visiblefor: ['admin', 'super'],
                link: '/anagrafiche/wsustradenglist',
                parentId: 82
            } ,
            {
                id: 83,
                label: 'CAP',
                visiblefor: ['admin', 'super'],
                link: '/commons/capnglist',
                parentId: 82
            } ,
            {
                id: 83,
                label: 'Masterdata',
               visiblefor: ['admin', 'super'],
                link: '/anagrafiche/masterdatanglist',
                parentId: 82
            }  
        ]
    },
    
    {
        id: 143,
        label: 'CONRATTI',
         visiblefor:  ['all'],
        icon: 'bx-share-alt',
        subItems: [
            {
                id: 144,
                label: 'Schede canone',
                 visiblefor:  ['all'],
                link: '/commons/wsuschedalist',
                parentId: 143
            },
          
            {
                id: 144,
                label: 'Contratti',
                 visiblefor:  ['all'],
                link: '/commons/orchestratorlist',
                parentId: 143
            },
             
        ]
    },
     {
        id: 98,
        label: 'AREA PERSONALE',
        visiblefor: ['admin','manager'],
        icon: 'bx bx-key',
        subItems: [
            {
                id: 55,
                label: 'Azienda',
                visiblefor:  ['admin'],
                link: '/commons/wfconfiglist',
                parentId: 13
            },
            {
                id: 99,
                label: 'I miei dati', 
                  visiblefor: ['admin','manager'],
                link: '/settings/mydataform',
                parentId: 98
            },  
            {
                id: 83,
                label: 'Logging',
                 visiblefor:  ['admin'],
                link: '/commons/loglist',
                parentId: 82
            }, 
            {
                id: 88,
                label: 'G.D.P.R',
                    visiblefor: ['admin','manager'],
                link: '/pages/faqs',
                parentId: 82
            },
            {
                id: 100,
                label: 'Help Desk',
                visiblefor: ['admin','manager'],
                externalLink: 'https://suniasalerno-1749829367107.atlassian.net/',
                parentId: 98
            }, 
            
        ]
    },
     // 🔽 NUOVA VOCE Tutorial con sottovoci
                {
                id: 101,
                label: 'TUTORIAL',
                visiblefor: ['admin', 'manager','super'],
                icon: 'bx bx-video', 
                subItems: [
                    {
                    id: 102,
                    label: 'Presentazione',
                    action: 'openTutorialDialog',
                    visiblefor: ['admin', 'manager','super'],
                    video: 'assets/tutorials/login.mp4',
                    parentId: 101
                    },
                     {
                    id: 103,
                    label: 'Contratti',
                    visiblefor: ['admin', 'manager','super'],
                    icon: 'bx bx-video', 
                    subItems: [
                                            {
                                        id: 104,
                                        label: 'Elenco Contratti',
                                        action: 'openTutorialDialog',
                                        visiblefor: ['admin', 'manager','super'],
                                        video: 'assets/tutorials/elenco_contratti.mp4',
                                        parentId: 103
                                        },
                                        {
                                        id: 105,
                                        label: 'Nuovo Contratto',
                                        action: 'openTutorialDialog',
                                        visiblefor: ['admin', 'manager','super'],
                                        video: 'assets/tutorials/rigenera.mp4',
                                        parentId: 103
                                        },
                                        {
                                        id: 106,
                                        label: 'Rigenerazione Contratto',
                                        action: 'openTutorialDialog',
                                        visiblefor: ['admin', 'manager','super'],
                                        video: 'assets/tutorials/rigenera.mp4',
                                        parentId: 103
                                        } 
                                        ,
                                        {
                                        id: 107,
                                        label: 'Elimina Contratto',
                                        action: 'openTutorialDialog',
                                        visiblefor: ['admin','manager','super' ],
                                        video: 'assets/tutorials/eliminacontratto.mp4',
                                        parentId: 103
                                        },
                                        {
                                        id: 108,
                                        label: 'Modifica Contratto',
                                        action: 'openTutorialDialog',
                                        visiblefor: ['admin','manager','super' ],
                                        video: 'assets/tutorials/modcontratto.mp4',
                                        parentId: 103
                                        },
                                        {
                                        id: 109,
                                        label: 'Stampa Contratto',
                                        action: 'openTutorialDialog',
                                        visiblefor: ['admin','manager','super' ],
                                        video: 'assets/tutorials/stampacontratto.mp4',
                                        parentId: 103
                                        } ,
                                        {
                                        id: 110,
                                        label: 'Rigenera Contratto',
                                        action: 'openTutorialDialog',
                                        visiblefor: ['admin','manager','super' ],
                                        video: 'assets/tutorials/rigenera.mp4',
                                        parentId: 103
                                        }  
                                ]
                            },
                             {
                    id: 111,
                    label: 'Schede',
                    visiblefor: ['admin', 'manager','super'],
                    icon: 'bx bx-video', 
                    subItems: [
                    {
                                            id: 112,
                                            label: 'Elenco Schede',
                                            action: 'openTutorialDialog',
                                            visiblefor: ['admin', 'manager','super'],
                                            video: 'assets/tutorials/elencoschede.mp4',
                                            parentId: 111
                                    },
                                    {
                                            id: 113,
                                            label: 'Nuova Scheda',
                                            action: 'openTutorialDialog',
                                            visiblefor: ['admin', 'manager','super'],
                                            video: 'assets/tutorials/nuovascheda.mp4',
                                            parentId: 111
                                    },
                                     {
                                            id: 114,
                                            label: 'Elimina Scheda',
                                            action: 'openTutorialDialog',
                                            visiblefor: ['admin','manager','super' ],
                                            video: 'assets/tutorials/eliminascheda.mp4',
                                            parentId: 111
                                        },
                                        {
                                            id: 115,
                                            label: 'Modifica Scheda',
                                            action: 'openTutorialDialog',
                                            visiblefor: ['admin','manager','super' ],
                                            video: 'assets/tutorials/modscheda.mp4',
                                            parentId: 111
                                        }, 
                                        {
                                            id: 118,
                                            label: 'Stampa Scheda',
                                            action: 'openTutorialDialog',
                                            visiblefor: ['admin','manager','super' ],
                                            video: 'assets/tutorials/stampascheda.mp4',
                                            parentId: 111
                                        }, 

                            ]
                            },
                   
                    
                    {
                        id: 119,
                        label: 'Modifica Anagrafiche',
                        action: 'openTutorialDialog',
                        visiblefor: ['admin','super' ],
                        video: 'assets/tutorials/modificaanagrafiche.mp4',
                        
                    },
                    {
                        id: 120,
                        label: 'Modifica Password',
                        action: 'openTutorialDialog',
                        visiblefor: ['admin','manager','super' ],
                        video: 'assets/tutorials/aggiornapassword.mp4',
                    
                },
                
                {
                    id: 121,
                    label: 'Modifica Azienda',
                    action: 'openTutorialDialog',
                    visiblefor: ['admin','super' ],
                    video: 'assets/tutorials/modazienda.mp4',
                    
                },
                {
                    id: 122,
                    label: 'Logging',
                    action: 'openTutorialDialog',
                    visiblefor: ['admin','super' ],
                    video: 'assets/tutorials/logging.mp4',
                    
                },
                {
                    id: 123,
                    label: 'HelpDesk',
                    action: 'openTutorialDialog',
                    visiblefor: ['admin','manager','super' ],
                    video: 'assets/tutorials/helpdesk.mp4',
                    
                } 
                      
                ]
                },

    {
        id: 82,
        label: 'IMPOSTAZIONI',
        icon: 'bx-file',
        visiblefor:  ['super'],
        subItems: [
            {
                id: 55,
                label: 'Azienda',
                visiblefor:  ['super'],
                link: '/commons/wfconfiglist',
                parentId: 13
            },
            {
                id: 55,
                label: 'Gestione Utenti',
                visiblefor:  ['super'],
                link: '/settings/usersystemlist',
                parentId: 13
            },
            {
                id: 55,
                label: 'Gestione Ruoli',
                 visiblefor:  ['super'],
                link: '/settings/ruolipermessilist',
                parentId: 13
            },
            {
                id: 55,
                label: 'Editor Contratti',
                  visiblefor:  ['super'],
                link: '/commons/contracttemplatelist',
                parentId: 13
            }
            ,
            {
                id: 144,
                label: 'Clausole',
                link: '/commons/contractdatalist',
                 visiblefor:  ['super'],
                parentId: 143
            },
            {
                id: 83,
                label: 'Logging',
                 visiblefor:  ['super'],
                link: '/commons/loglist',
                parentId: 82
            }, 
            {
                id: 88,
                label: 'G.D.P.R',
                  visiblefor:  ['super'],
                link: '/pages/faqs',
                parentId: 82
            },
             {
                id: 100,
                label: 'Help Desk',
                visiblefor:  ['super'],
                externalLink: 'https://id.atlassian.com/login',
                parentId: 98
                },
        /*    {
                id: 88,
                label: 'Prezzi',
                 visiblefor: 'admin',
                link: '/pages/pricing',
                parentId: 82
            },*/
        ]
    },
     
];

